// extracted by mini-css-extract-plugin
module.exports = {"absoluteCenter":"Loading_absoluteCenter__3Jcvl"};